import { configureStore } from "@reduxjs/toolkit";
import {
  persistStore,
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from "redux-persist";
import storage from "redux-persist/lib/storage";
import storageSession from "redux-persist/lib/storage/session";
import { combineReducers } from "@reduxjs/toolkit";
import authReducer from "./slices/authSlice";
import warehouseReducer from "./slices/warehouseSlice";

const authPersistConfig = {
  key: "auth",
  storage: storageSession,
  blacklist: ["isInitializing"],
};

const warehousePersistConfig = {
  key: "warehouse",
  storage: storage,
  blacklist: ["isLoading"],
};

const rootReducer = combineReducers({
  auth: persistReducer(authPersistConfig, authReducer),
  warehouse: persistReducer(warehousePersistConfig, warehouseReducer),
});

const persistConfig = {
  key: "root",
  version: 1,
  storage: storage,
  whitelist: [],
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
});

export const persistor = persistStore(store);

export type RootState = ReturnType<typeof rootReducer>;
export type AppDispatch = typeof store.dispatch;
